import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { AllOrderList } from 'src/app/models/customer/customer.model';
import { PagingModel } from 'src/app/models/paging/paging.model';
import { ProductListingModel, ProductResponseModel, RelatedProductList, RelatedProductListModel } from 'src/app/models/product/productListing.modal';
import { UpdateRelatedProduct, UpdateRelatedProductModel } from 'src/app/models/product/relatdProduct';
import { ProductNameComponent } from 'src/app/modules/layoutShopModule/shop-components/product-name/product-name.component';
import { AlertifyService } from 'src/app/services/Common/alertify.service';
import { HomePageService } from 'src/app/services/home-page.service';
import { ProductService } from 'src/app/services/product.service';
import { RelatedProductsDeletedComponent } from '../related-products-deleted/related-products-deleted.component';

@Component({
  selector: 'app-related-products',
  templateUrl: './related-products.component.html',
  styleUrls: ['./related-products.component.css']
})
export class RelatedProductsComponent implements OnInit {
  Loader: boolean = false;
  productlisting: ProductListingModel = new ProductListingModel();
  productResponseModel: ProductResponseModel;
  filteredCategories: Array<string> = [];
  filteredCateg: Array<string> = [];
  searchValue: string = "";
  getCategories: [];
  productId: string;
  imageLoader: boolean = false;
  recomendedProductIds: string;
  ProductId: number;
  adminAllOrderList: AllOrderList = new AllOrderList();
  updateRelatedProduct = new UpdateRelatedProduct();
  updateRelatedProductModel: UpdateRelatedProductModel = new UpdateRelatedProductModel();
  relatedProductItems: Array<RelatedProductList>
  relatedProductListModel: RelatedProductListModel = new RelatedProductListModel();
  totalPages: number;
  pageNumber: number = 1;
  pagingModel: PagingModel = new PagingModel();
  checkedRelatedProductItems: Array<RelatedProductList>;
  selectedId: any;

  constructor(private productService: ProductService,  private modalService: NgbModal, private homePageService: HomePageService, private alertify: AlertifyService, private route: Router, private router: ActivatedRoute) {

    this.productResponseModel = new ProductResponseModel();
    this.relatedProductItems = new Array<RelatedProductList>();
    this.checkedRelatedProductItems = new Array<RelatedProductList>();
    this.pagingModel.pageNumber = 1;
    if (this.totalPages == undefined || this.totalPages == 0) {
      this.totalPages = 1;
    }

  }

  ngOnInit() {
    this.router.params.subscribe((param) => {
      this.productId = param.id;
    })
    this.router.params.subscribe((param) => {
      this.recomendedProductIds = param.id;
    })
    this.relatedProductListing();
    this.getAllCategories();
    

  }

  getAllCategories() {
    this.productService.getCategories().subscribe(response => {
      var responseBody = JSON.parse(response._body);
      if (responseBody.isSuccess) {
        this.getCategories = responseBody.responseData;
      }
    });
  }

  resetFilter() {
    this.searchValue = "";
    this.filteredCategories = [];
    this.getAllCategories();
    this.relatedProductListing();
  }

  filter() {
    this.productlisting.KeyWord = this.searchValue;
    this.productlisting.CategoryIds = this.filteredCategories.join(",");
    this.relatedProductListing();
  }
  
  loadPage(pagingModel: PagingModel) {
    this.productlisting.PageNumber = pagingModel.pageNumber;
    this.productlisting.PageSize = pagingModel.pageSize;
    this.relatedProductListing();
  }

  relatedProductListing() {
    this.Loader = true;
    this.productlisting.CategoryIds = this.filteredCategories.join(",");
    this.productlisting.KeyWord = this.searchValue;
    this.productlisting.ProductId = this.productId;
    this.productService.releatedProductsListing(this.productlisting).subscribe(response => {
      this.Loader = false;
      var responseBody = JSON.parse(response._body);
      if (responseBody.isSuccess) {
        this.getRelatedProduct();
        this.relatedProductItems = [];
        this.productResponseModel.ProductList = responseBody.responseData;
        for (var i = 0; i < responseBody.responseData.length; i++) {
          var item = responseBody.responseData[i];
          var productItems = new RelatedProductList();
          productItems.id = item.productId;
          productItems.productName = item.productName;
          productItems.priceFormatted = item.productPriceFormatted;
          productItems.categoryNames = item.categoryNames;
          productItems.isSelected = false;
          this.relatedProductItems.push(productItems);
        }
        this.relatedProductItems.forEach((element, index) => {
          this.relatedProductItems[index].imageLoader = true;
          this.ProductId = element.id;
          this.homePageService.ProductImageList(this.ProductId)
            .subscribe((response) => {
              let responseimage = JSON.parse(response._body)
              if (responseimage.isSuccess) {
                this.relatedProductItems[index].productImage = responseimage.responseData;
                this.relatedProductItems[index].imageLoader = false;
              }
              (err) => {
                this.Loader = false;
              }
            })
        });
        this.productResponseModel.TotalPages = responseBody.totalPages;
        this.totalPages = this.productResponseModel.TotalPages == undefined ? 0 : this.productResponseModel.TotalPages;
      }
      else {
        this.Loader = false;
      }
    })
  }

  setSelectedRelatedProducts(item: RelatedProductList, event) {
    for (var j = 0; j < this.relatedProductItems.length; j++) {
      if (this.relatedProductItems[j].id == item.id) {
        this.relatedProductItems[j].isSelected = !this.relatedProductItems[j].isSelected;
        this.selectedId = item.id;
        console.log(item.id)
        break;
      }

    }
  }

  onSubmit() {
    this.Loader = true;
    this.updateRelatedProduct.ProductId = this.productId;
    this.updateRelatedProduct.RelatedProductIds = this.selectedId;
    var warrantyServiceId = [];
    for (var j = 0; j < this.relatedProductItems.length; j++) {
      if (this.relatedProductItems[j].isSelected) {
        warrantyServiceId.push(this.relatedProductItems[j].id.toString());
      }
    }
    this.updateRelatedProduct.RelatedProductIds = warrantyServiceId.toString();
    this.productService.updateRelatedProducts(this.updateRelatedProduct)
      .subscribe((response) => {
        var responseBody = JSON.parse(response._body);
        this.Loader = false;
        if (responseBody.isSuccess) {
          this.alertify.success(responseBody.responseData);
          this.relatedProductListing();
        }
        else {
          this.alertify.error(responseBody.responseMessage);
        }
        this.Loader = false;
      });
  }

  getRelatedProduct() {
    this.updateRelatedProductModel.ProductId = +this.productId;
    this.productService.getRelatedProductId(this.updateRelatedProductModel.ProductId)
      .subscribe((response) => {
        this.checkedRelatedProductItems = [];
        var responseBody = JSON.parse(response._body);
        for (var i = 0; i < responseBody.responseData.length; i++) {
          var item = responseBody.responseData[i];
          var relatedProductItems = new RelatedProductList();
          relatedProductItems.id = item.id;
          relatedProductItems.productTitle = item.productTitle;
          relatedProductItems.priceFormatted = item.productPriceFormatted;
          relatedProductItems.discount = item.discountPercent;
          relatedProductItems.isSelected = false;
          this.checkedRelatedProductItems.push(relatedProductItems);
        }
        this.checkedRelatedProductItems.forEach((element, index) => {
          this.checkedRelatedProductItems[index].imageLoader = true;
          this.ProductId = element.id;
          this.homePageService.ProductImageList(this.ProductId)
            .subscribe((response) => {
              let responseimage = JSON.parse(response._body)
              if (responseimage.isSuccess) {
                this.checkedRelatedProductItems[index].productImage = responseimage.responseData;
                this.checkedRelatedProductItems[index].imageLoader = false;
              }
              (err) => {
                this.Loader = false;
              }
            })
        });
      });
  }

  singleRelatedProductDelete(item) {
    var modalConfig = new NgbModalConfig();
    modalConfig.size = "lg";
    modalConfig.centered = true;
    modalConfig.backdrop = false;
    modalConfig.keyboard = false;
    this.productService.passProductId(item.id);
    let modalRef = this.modalService.open(RelatedProductsDeletedComponent, modalConfig);
    modalRef.componentInstance.ProductId = item.id;
    modalRef.result.then(() => {
    }, (reason) => {
      this.relatedProductListing();
    });
}

productImage(item) {
  const url = this.route.serializeUrl(
    this.route.createUrlTree(['/product-page/' + item.id]));
  window.open('#' + url, '_blank');
}

shopProductName(item) {
  var modalConfig = new NgbModalConfig();
  modalConfig.size = "sm";
  modalConfig.centered = true;
  modalConfig.backdrop = false;
  modalConfig.keyboard = false;
  let modalRef = this.modalService.open(ProductNameComponent, modalConfig);
  modalRef.componentInstance.productTitle = item.productTitle;
}

  }


